import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../../Components/InputAHSF";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import {
  GetOneSC_NT_RI_ResearcherIndicators,
  setResearcherIndicators,
} from "../../../Redux/Reducers/Submitter/ResearcherIndicators";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ResearchersIndicators = (props) => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);
   const {ApplicationInformationId} = useParams();
  const state = useSelector((state) => {
    return {
      ResearcherIndicators: state.ResearcherIndicators.ResearcherIndicators,
      SC_NT_AI_ApplicationInformation:
        state.SC_NT_AI_ApplicationInformation.SC_NT_AI_ApplicationInformation,
    };
  });
  const ValidationScientificContributionSubmitted = useSelector(
    (state) =>
      state.ValidationScientificContributionSubmitted
        .ValidationScientificContributionSubmitted
  );
  const ValiationList = ValidationScientificContributionSubmitted?.result?.map(
    (ele) => ele.code
  );
  const [ResearcherIndicatorsData, setResearcherIndicatorsData] = useState({});
  const getData = async () => {
    const data = await dispatch(
      GetOneSC_NT_RI_ResearcherIndicators({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        )||
          ApplicationInformationId,
      })
    );
    if (data.payload) {
      setResearcherIndicatorsData({ ...data.payload });
    }
  };

  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);

  useEffect(() => {
    dispatch(setResearcherIndicators({ ...ResearcherIndicatorsData }));
  }, [ResearcherIndicatorsData]);

  console.log(
    state.ResearcherIndicators,
    "ResearcherIndicatorsData",
    ResearcherIndicatorsData
  );

  return state.ResearcherIndicators && ResearcherIndicatorsData ? (
    <div className="form-grid">
      <InputAHSF
        fieldsName="h-index"
        type="number"
        show={true}
        lang={lang}
        disabled={props.disabled}
        value={ResearcherIndicatorsData?.h_index}
        onChange={(e) => {
          setResearcherIndicatorsData({
            ...ResearcherIndicatorsData,
            h_index: e.target.value,
          });
        }}
        showValidationMessage={
          ValiationList?.includes("h-index") ? true : false
        }
        validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
      />

      <InputAHSF
        fieldsName="i10-index"
        type="number"
        show={true}
        lang={lang}
        disabled={props.disabled}
        value={ResearcherIndicatorsData?.i10_index}
        onChange={(e) => {
          setResearcherIndicatorsData({
            ...ResearcherIndicatorsData,
            i10_index: e.target.value,
          });
        }}
        showValidationMessage={
          ValiationList?.includes("i10-index") ? true : false
        }
        validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
      />
      <div></div>
      <InputAHSF
        fieldsName="GoogleScholar"
        show={true}
        lang={lang}
        disabled={props.disabled}
        value={ResearcherIndicatorsData?.researcherGoogleScholarLink}
        onChange={(e) => {
          setResearcherIndicatorsData({
            ...ResearcherIndicatorsData,
            researcherGoogleScholarLink: e.target.value,
          });
        }}
        showValidationMessage={
          ValiationList?.includes("GoogleScholar") ? true : false
        }
        validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
      />
      <InputAHSF
        fieldsName="Scopus"
        show={true}
        lang={lang}
        disabled={props.disabled}
        value={ResearcherIndicatorsData?.researcherScopusLink}
        onChange={(e) => {
          setResearcherIndicatorsData({
            ...ResearcherIndicatorsData,
            researcherScopusLink: e.target.value,
          });
        }}
        showValidationMessage={ValiationList?.includes("Scopus") ? true : false}
        validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
      />
      {state.SC_NT_AI_ApplicationInformation?.fieldId ==
      "03821a6b-0988-4fb7-9ba8-d1ef3bab5b27" ? (
        <InputAHSF
          fieldsName="PubMed"
          show={true}
          lang={lang}
          disabled={props.disabled}
          value={ResearcherIndicatorsData?.researcherPubMedLink}
          onChange={(e) => {
            setResearcherIndicatorsData({
              ...ResearcherIndicatorsData,
              researcherPubMedLink: e.target.value,
            });
          }}
          showValidationMessage={
            ValiationList?.includes("PubMed") ? true : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
      ) : (
        ""
      )}
    </div>
  ) : (
    ""
  );
};

export default ResearchersIndicators;
